const IndustryInformation = () => import('@/pages/industryInformation/index.vue');

export default [{
    path: '/industryInformation',
    name: 'industryInformation',
    component: IndustryInformation
  },
 
]